import { buildApiUrl, Type, sendGetRequest } from '@/api/api';
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export interface TariffYearsParams {
  tariffIds?: number[]
  provinceIds?: number[]
  providerIds?: number[]
}

export async function fetchTariffYears(params: TariffYearsParams) {
  const url = buildApiUrl(Type.TariffManagement, 'tariffs/years')
  if (params.tariffIds?.length)   url.searchParams.set('tariffIds',   params.tariffIds.join(','))
  if (params.provinceIds?.length) url.searchParams.set('provinceIds', params.provinceIds.join(','))
  if (params.providerIds?.length) url.searchParams.set('providerIds', params.providerIds.join(','))
  const { data } = await sendGetRequest(url)
  return assertSchemaAndCoerce(data, z.array(z.string()))
}
